import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QResult } from '../../../../../models';
import { FormateurData, ReservationDataDoc, ReservationDocModel } from '../../../../../models/formation';
import { CoreService, HttpService, QueovalDateService, UtilitiesService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { StageService } from '../../services/stage-modal.service';
import { Subject, Subscription } from 'rxjs';
import { DocxPreselect } from '../../../../../models/document/model.docx.preselect';


@Component({
  selector: 'queoval-stage-list-reservation',
  templateUrl: './list-reservation.component.html',
  styleUrls: ['./list-reservation.component.css']
})
/** Composant qui envoie la liste d'ident des réservations sélectionnées */
export class ListReservationComponent implements OnInit {

  //#region Constructeur

  constructor(
    public service: StageService,
    private http: HttpService,
    private indParam: CoreService,
    private toast: ToastService,
    public qDateService: QueovalDateService,
    public utilities: UtilitiesService
  ) { }

  //#endregion Constructeur

  //#region Variables globals

  /** Model global */
  //les données on été Init une première fois
  private dataCalled: boolean = false;
  public model: ReservationDocModel;
  /** boolean pour sélectionnées toutes les réservations*/
  public allReservationAreSelected: boolean;
  /**  boolean permettant d'indiquer si la date de fin est valide */
  public isDateFin: boolean;
  /** boolean permettant d'indiquer si la date de début est valide*/
  public isDateDebut: boolean;
  /** @Input Ident du Formateur*/
  public identFormateur: string;
  @Input('IdentFormateur')
  set SetIdentFormateur(value: string) {
    let reloadData: boolean = this.dataCalled && this.identFormateur != value;
    this.identFormateur = value;
    if (reloadData)
      this.InitData();
  }

  @Input('docxpreselect$') docxpreselect$: Subject<DocxPreselect>;
  private subscription: Subscription;

  /** active ou desactive le mode cursus 0 = false, 1 = true*/
  @Input() IsModeCursus: string;
  /** @Input liste d'ident des reservations selectionnées*/
  @Input() LstIdReservationChecked: Array<string>;
  /** @Output liste d'ident des reservations */
  @Output() LstIdReservation = new EventEmitter<string[]>();
  /** liste d'ident intermediaire qui sera envoyé à l'Output*/
  public LstIdentReservations: string[];
  /** liste utilisé pour afficher les réservations qui sont affichées*/
  public LstReservationFilter: ReservationDataDoc[];
  /** liste utilisé pour récupérer les ident des formateur (Avatar-search)*/
  public LstIdentFormateurFilter: FormateurData[];
  /** boolean pour savoir si un id formateur a été envoyé*/
  public HasIdFormateur: boolean;

  public randomNumber: number;

  //#endregion Variables globals

  //#region Cycle de vie

  ngOnInit(): void {
    this.model = new ReservationDocModel();
    this.allReservationAreSelected = false;
    this.LstIdentReservations = [];
    this.LstReservationFilter = [];
    this.LstIdentFormateurFilter = [];
    this.HasIdFormateur = false;
    this.isDateDebut = true;
    this.isDateFin = true;
    this.InitData();
    this.dataCalled = true;
  }

  ngAfterViewInit(): void {
    if (this.docxpreselect$ != null) {
      this.subscription = this.docxpreselect$.subscribe(valeur => {
        this.allReservationAreSelected = valeur.Ckplanning == "1";
        this.AddRemoveAllReservation();
      });
    }
  }
  ngOnDestroy(): void {
    if (this.subscription != null)
      this.subscription.unsubscribe();
  }

  //#endregion Cycle de vie

  //#region Fonctions Publics

  /**
   * fonction qui récupere la liste des formateurs sélectionnés
   * @param e event de l'Avatar-search
   */
  public OnFormateurChange(e: FormateurData[]) {
    this.LstIdentFormateurFilter = e;
    this.OnFilterChange();
  }

  /**
   * fonction qui permet de filtrer les réservations en fonction des dates ou des formateurs
   * */
  public OnFilterChange() {
    //partie filtre formateur
    if (this.LstIdentFormateurFilter.length > 0) {
      this.LstReservationFilter = this.model.LstReservation.filter(l1 => l1.LstFormateurRattache.some(l2 => this.LstIdentFormateurFilter.some(l3 => l2.Ident === l3.Ident)));

    } else {

      if (this.model.LstReservation) {
        this.LstReservationFilter = [...this.model.LstReservation]
      }
      else {
        this.LstReservationFilter = [];
      }
    }

    //partie filtre date

    //verifie que la date de fin soit supérieur à date de début
    if (this.qDateService.Compare(this.model.FiltreDateDebut, '>', this.model.FiltreDateFin)) {
      this.toast.showAlertToast('La date de début se trouve après la date de fin pour le planning');
      this.LstReservationFilter = [];
    }

    this.LstReservationFilter = this.LstReservationFilter.filter(x => {
      return this.qDateService.Compare(x.DateDebut, '>=', this.model.FiltreDateDebut) && this.qDateService.Compare(x.DateFin, '<=', this.model.FiltreDateFin);
    })
  }

  /**
   *  Ajoute ou supprime toutes les réservations dans la liste
   * */
  public AddRemoveAllReservation() {

    //if (this.HasIdFormateur) {
    //   this.LstReservationFilter = this.LstReservationFilter.filter(l1 => l1.LstFormateurRattache.some(l2 => l2.Ident === this.identFormateur));
    //}
    
    if (this.allReservationAreSelected) {
      if (this.HasIdFormateur) {
        this.LstIdentReservations = [];
        this.LstReservationFilter.forEach(x => x.LstFormateurRattache.forEach(y => this.LstIdentReservations.push(y.Ident)));
        this.LstReservationFilter.forEach(x => {
            x.IsSelected = true;
        })
      }
      else {
        this.LstReservationFilter.forEach(x => {
          if (!this.LstIdentReservations.includes(x.Ident)) {
            this.LstIdentReservations.push(x.Ident)
            x.IsSelected = true;
          }
        })
      }
      
    } else {
      this.LstReservationFilter.forEach(x => x.IsSelected = false)
      this.LstIdentReservations = [];
    }
    
    this.LstIdReservation.emit(this.LstIdentReservations);   
  }

  /**
   * Ajoute ou supprime une réservation dans la liste
   * @param reservation reservation sélectionné
   */
  public AddRemoveReservation(reservation: ReservationDataDoc) {
    reservation.IsSelected = !reservation.IsSelected;
    let indexDelete: number | null = null;
    this.LstIdentReservations.forEach((x, index) => {
      if (x == reservation.Ident) {
        indexDelete = index;
      }
    });
    indexDelete == null ? this.LstIdentReservations.push(reservation.Ident) : this.LstIdentReservations.splice(indexDelete, 1);

    this.LstIdReservation.emit(this.LstIdentReservations);
  }

  //#endregion Fonctions Publics



  //#region Fonction Privates

  /**
*  charge la liste des réservations,formateurs à afficher
* */
  private InitData() {
    //pipe pour séparer l'ident du stage et l'ident du formateur
    //this.HasIdFormateur = !isEmptyStr(this.identFormateur);
    const dataSend = this.utilities.isEmptyStr(this.identFormateur) ? `${this.service.Stage.Ident}||${this.IsModeCursus}` : `${this.service.Stage.Ident}|${this.identFormateur}|${this.IsModeCursus}`;
    
    
    this.http.getHttp<QResult<ReservationDocModel>>(`${this.indParam.AppParams.apiUrl}api/Stage/Document/INIT_RESERVATIONS/${dataSend}`)
      .subscribe((result: QResult<ReservationDocModel>) => {
        if (!result.HasError) {
          this.model = result.Value;
          this.LstReservationFilter = result.Value.LstReservation;

          if (this.qDateService.Compare(result.Value.FiltreDateDebut, '>', this.service.Stage.DateDebut)) {
            this.model.FiltreDateDebut = this.service.Stage.DateDebut;
          }
          else {
            this.model.FiltreDateDebut = result.Value.FiltreDateDebut;
          }

          if (this.qDateService.Compare(result.Value.FiltreDateFin, '<', this.service.Stage.DateFin)) {
            this.model.FiltreDateFin = this.service.Stage.DateFin;
          }
          else {
            this.model.FiltreDateFin = result.Value.FiltreDateFin; 
          }
                  
          if (this.LstIdReservationChecked && this.LstIdReservationChecked.length > 0) {
            this.LstReservationFilter.forEach(reservation => {
              if (this.LstIdReservationChecked.includes(reservation.Ident)) {
                reservation.IsSelected = true;
                this.LstIdentReservations.push(reservation.Ident)
              }
            })
          }
          else {
            this.AddRemoveAllReservation();
          }

          this.OnFilterChange();
          
        }
      });
    this.randomNumber = Math.floor(Math.random() * (1000));
  }

  //#endregion Fonction Privates

}
